// apps/app/src/features/chat/Messages/Item/Actions.tsx
import { IconButton } from '@/components/ui/icon-button'
import * as Menu from '@/components/ui/menu'
import type { MenuSelectionDetails } from '@ark-ui/solid'
import { appDialogConfirm } from '@components'
import { useAuth } from '@stateApp'
import { Link, MoreHorizontal, Pencil, Reply, Trash } from 'lucide-solid'
import { Show } from 'solid-js'
import { useService } from 'solid-services'
import { HStack } from 'styled-system/jsx'
import { useUpsert } from '../../state'
import type { DisplayMessage } from '../../state/resources/getChannelHistory'
import { useDelete } from '../../state/useDelete'
import ReactionsPick from './ReactionsPick'

enum Options {
  Delete = 'Delete',
  Edit = 'Edit',
  CopyLink = 'CopyLink',
}

const Actions = (props: {
  message: DisplayMessage
  channelPathRoot: string
  isMine?: boolean
  isMinimal?: boolean
  onReaction: (emoji: string) => void // <-- Added Prop
}) => {
  const { setDeletingId } = useService(useDelete)()
  const { isSuper } = useService(useAuth)()
  const { setEditingMessage, setReplyMessage } = useService(useUpsert)()

  const onSelect = (details: MenuSelectionDetails) => {
    switch (details.value) {
      case Options.Delete:
        appDialogConfirm(
          () => setDeletingId(props.message.id),
          'Are you sure you want to delete this Message?',
        )()
        break
      case Options.Edit:
        setEditingMessage(props.message)
        break
      case Options.CopyLink:
        navigator.clipboard.writeText(
          `${location.origin}${props.channelPathRoot}/message/${props.message.id}`,
        )
        break
    }
  }

  return (
    <>
      <Show when={!props.isMinimal}>
        <IconButton
          variant="plain"
          size="xs"
          onClick={() => setReplyMessage(props.message)}
        >
          <Reply />
        </IconButton>
      </Show>
      <Menu.Root
        onSelect={onSelect}
        positioning={{
          offset: { mainAxis: -15 },
        }}
      >
        <Menu.Trigger asChild={props => (
          <IconButton {...props} variant="plain" size="xs">
            <MoreHorizontal />
          </IconButton>
        )} />
        <Menu.Positioner>
          <Menu.Content>
            <Menu.ItemGroup>
              <Menu.Item value={Options.CopyLink}>
                <HStack gap={2}>
                  <Link /> Copy Link
                </HStack>
              </Menu.Item>
              <Show when={isSuper() || props.isMine}>
                <Menu.Item value={Options.Edit}>
                  <HStack gap={2}>
                    <Pencil /> Edit
                  </HStack>
                </Menu.Item>
                <Menu.Item value={Options.Delete} color="fg.error">
                  <HStack gap={2}>
                    <Trash color="var(--colors-fg-error)" /> Delete
                  </HStack>
                </Menu.Item>
              </Show>
            </Menu.ItemGroup>
          </Menu.Content>
        </Menu.Positioner>
      </Menu.Root>
      <ReactionsPick
        onReaction={props.onReaction} // <-- Passed through
      />
    </>
  )
}

export default Actions
